import { getTextFromHtml } from "helpers/common";
import sanitize from "helpers/sanitize";
import { useEffect, useMemo } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const editorModules = {
  toolbar: [
    ['bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered' }]
  ]
};

const editorFormats = ['bold', 'italic', 'underline', 'bullet', 'list'];

export default function EditorInput({ className, maxLength = 1000, threshold = 800, value, onChangeCallback, validate = null, readOnly = false, placeholder = null, showCount = false, ...rest }) {
  const textLength = useMemo(() => {
    const currentText = getTextFromHtml(sanitize(value));
    return currentText ? currentText.length : 0;
  }, [value]);

  const currentLength = useMemo(() => {
    if (showCount || textLength >= threshold) {
      return textLength;
    }
    return null;
  }, [textLength, threshold, showCount]);

  const isExceeded = useMemo(() => {
    if (maxLength && currentLength !== null && currentLength > maxLength) return true;
    return false;
  }, [currentLength]);

  useEffect(() => {
    if (validate) validate(isExceeded);
  }, [isExceeded]);

  return <div {...rest}>
    <ReactQuill className={className + (isExceeded ? ' is-invalid-quill' : '')} theme="snow" modules={editorModules} formats={editorFormats} value={value} onChange={onChangeCallback} readOnly={readOnly} placeholder={placeholder} />
    {
      (maxLength && currentLength !== null) && <div className="text-right">
        <small className={isExceeded ? 'text-primary' : ''}>{currentLength}/{maxLength}</small>
      </div>
    }
  </div>;
}
